import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import {
    Box,
    Button,
    Container,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Pagination,
    TextField,
    Paper,
    TableContainer,
    Chip,
    Stack,
    Card,
    CardContent,
    CircularProgress,
    Typography
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import axios from "axios";
import { useEffect, useState, useRef, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React from "react";

const CustomDateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder={placeholder || "Chọn ngày"}
        style={{
            height: "38px",
            padding: "0 12px",
            borderRadius: "6px",
            border: "1px solid #cbd5e1",
            outline: "none",
            fontSize: "13px",
            color: "#334155",
            backgroundColor: "#ffffff",
            width: "130px",
            textAlign: "center",
            cursor: "pointer",
            fontWeight: 500
        }}
        readOnly
    />
));

function Request() {
    const formatDateTime = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const formatPoints = (val) => {
        const num = Number(val) || 0;
        const rounded = Math.round(num * 100) / 100;
        return rounded.toLocaleString("vi-VN", { maximumFractionDigits: 2 });
    };

    const getBetAndLoss = (item) => {
        if (!item) return { tongCuoc: 0, tongThua: 0 };
        if (typeof item.tongCuoc === "number" || typeof item.tongThua === "number") {
            return {
                tongCuoc: item.tongCuoc || 0,
                tongThua: item.tongThua || 0
            };
        }
        const money = Number(item.money) || 0;
        const detail = item.detail || "";
        const match = detail.match(/tỉ lệ\s+([\d.]+)\%/i) || detail.match(/([\d.]+)\%/i);
        let ratePercent = null;
        if (match && match[1] && Number(match[1]) > 0) {
            ratePercent = Number(match[1]);
        }
        const isLossRebate = /cược\s+thua|thua/i.test(detail);
        if (ratePercent) {
            const calculatedBase = Math.round(money / (ratePercent / 100));
            if (isLossRebate) {
                return {
                    tongCuoc: calculatedBase,
                    tongThua: calculatedBase
                };
            } else {
                return {
                    tongCuoc: calculatedBase,
                    tongThua: 0
                };
            }
        } else {
            if (isLossRebate) {
                    return { tongCuoc: money, tongThua: money };
            }
            return { tongCuoc: money, tongThua: 0 };
        }
    };

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    // States quản lý phân trang và tìm kiếm Server-side
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [datePreset, setDatePresetState] = useState("all");
    const [status, setStatus] = useState("All");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [totalDeny, setTotalDeny] = useState(0);
    const [estimatedTotalBet, setEstimatedTotalBet] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - offset * 60 * 1000);
        return localDate.toISOString().split("T")[0];
    };

    const fetchRefunds = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}/payment/hoantra?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}`
            )
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setTotalDeny(res.data.totalDeny || 0);
                setEstimatedTotalBet(res.data.estimatedTotalBet || 0);
                setTotalRecords(res.data.totalRecords || (res.data.data ? res.data.data.length : 0));
                setLoading(false);
            })
            .catch((err) => {
                console.error("Lỗi lấy lịch sử hoàn tiền:", err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        setDatePresetState(preset);
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchRefunds();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1);
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    const handleUpdateStatus = (id, newStatus) => {
        const isAccept = newStatus === "Accept";
        swal({
            title: isAccept ? "Xác nhận duyệt hoàn tiền?" : "Từ chối hoàn tiền?",
            text: isAccept
                ? "Thao tác này sẽ duyệt khoản tiền hoàn trả cho thành viên."
                : "Thao tác này sẽ từ chối yêu cầu hoàn tiền này.",
            icon: isAccept ? "info" : "warning",
            buttons: ["Hủy", isAccept ? "Duyệt ngay" : "Từ chối"],
            dangerMode: !isAccept
        }).then((willProcess) => {
            if (!willProcess) return;
            setLoading(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/payment/update`, { id, status: newStatus })
                .then(() => {
                    swal("Thành công", isAccept ? "Đã duyệt hoàn tiền!" : "Đã từ chối hoàn tiền!", "success");
                    fetchRefunds();
                })
                .catch((err) => {
                    swal("Lỗi", err.response?.data?.message || "Không thể thực hiện thao tác!", "error");
                    fetchRefunds();
                });
        });
    };

    const renderStatusBadge = (statusPayment) => {
        switch (statusPayment) {
            case "Success":
            case "Accept":
                return (
                    <Chip
                        label="Thành công"
                        size="small"
                        sx={{ bgcolor: "#dcfce7", color: "#15803d", border: "1px solid #86efac", fontWeight: 700, fontSize: "12px" }}
                    />
                );
            case "Pending":
                return (
                    <Chip
                        label="Chờ duyệt"
                        size="small"
                        sx={{ bgcolor: "#fef3c7", color: "#b45309", border: "1px solid #fde047", fontWeight: 700, fontSize: "12px" }}
                    />
                );
            case "Deny":
                return (
                    <Chip
                        label="Từ chối"
                        size="small"
                        sx={{ bgcolor: "#fee2e2", color: "#b91c1c", border: "1px solid #fca5a5", fontWeight: 700, fontSize: "12px" }}
                    />
                );
            default:
                return (
                    <Chip
                        label={statusPayment || "Không rõ"}
                        size="small"
                        sx={{ bgcolor: "#f1f5f9", color: "#475569", fontWeight: 600, fontSize: "12px" }}
                    />
                );
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 3, px: { xs: 2, md: 4 }, bgcolor: "#f8fafc", minHeight: "100vh", width: "100%", fontFamily: '"Roboto", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important', "& *": { fontFamily: "inherit" } }}>
                    <Container maxWidth={false} disableGutters sx={{ width: "100%" }}>
                        {/* Header Title */}
                        <Box className="refund-header" sx={{ mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
                            <Box>
                                <Typography variant="h5" sx={{ fontWeight: 800, color: "#0f172a", display: "flex", alignItems: "center", gap: 1 }}>
                                    <PaymentsRoundedIcon sx={{ color: "#2563eb", fontSize: 24 }} /> Lịch sử hoàn tiền
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#64748b", mt: 0.5 }}>
                                    Quản lý, tìm kiếm, xem thống kê cược và duyệt các yêu cầu hoàn trả tiền cược của thành viên.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Thống kê Tổng quan (5 KPI Cards Spanning 100% Width) */}
                        <Box className="refund-kpis" sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(5, 1fr)" }, gap: 2, mb: 3, width: "100%" }}>
                            <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff" }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "11px" }}>
                                                Hoàn Trả Thành Công
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: "#16a34a", mt: 0.5, fontSize: "17px" }}>
                                                {formatPoints(totalSuccess)} <span style={{ fontSize: "12px", fontWeight: 600 }}>điểm</span>
                                            </Typography>
                                        </Box>
                                        <Box sx={{ width: 38, height: 38, borderRadius: "8px", bgcolor: "#dcfce7", color: "#16a34a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                                            <CheckCircleRoundedIcon fontSize="small" />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff" }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "11px" }}>
                                                Hoàn Trả Chờ Duyệt
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: "#d97706", mt: 0.5, fontSize: "17px" }}>
                                                {formatPoints(totalPending)} <span style={{ fontSize: "12px", fontWeight: 600 }}>điểm</span>
                                            </Typography>
                                        </Box>
                                        <Box sx={{ width: 38, height: 38, borderRadius: "8px", bgcolor: "#fef3c7", color: "#d97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                                            <HourglassTopRoundedIcon fontSize="small" />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff" }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "11px" }}>
                                                Hoàn Trả Bị Từ Chối
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: "#dc2626", mt: 0.5, fontSize: "17px" }}>
                                                {formatPoints(totalDeny)} <span style={{ fontSize: "12px", fontWeight: 600 }}>điểm</span>
                                            </Typography>
                                        </Box>
                                        <Box sx={{ width: 38, height: 38, borderRadius: "8px", bgcolor: "#fee2e2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                                            <CancelRoundedIcon fontSize="small" />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff" }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "11px" }}>
                                                Ước Tính Tổng Cược
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: "#7c3aed", mt: 0.5, fontSize: "17px" }}>
                                                {formatPoints(estimatedTotalBet)} <span style={{ fontSize: "12px", fontWeight: 600 }}>điểm</span>
                                            </Typography>
                                        </Box>
                                        <Box sx={{ width: 38, height: 38, borderRadius: "8px", bgcolor: "#f3e8ff", color: "#7c3aed", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                                            <CasinoRoundedIcon fontSize="small" />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff" }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "11px" }}>
                                                Tổng Số Bản Ghi
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: "#2563eb", mt: 0.5, fontSize: "17px" }}>
                                                {totalRecords} <span style={{ fontSize: "12px", fontWeight: 600 }}>bản ghi</span>
                                            </Typography>
                                        </Box>
                                        <Box sx={{ width: 38, height: 38, borderRadius: "8px", bgcolor: "#dbeafe", color: "#2563eb", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px" }}>
                                            <BarChartRoundedIcon fontSize="small" />
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>

                        {/* Thẻ Bộ Lọc Filter Card Spanning Full Width */}
                        <Card sx={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", mb: 3, bgcolor: "#ffffff", width: "100%" }}>
                            <CardContent sx={{ p: 2.5 }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    {/* Hàng lọc 1: Search, Status, DatePickers */}
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                                        <TextField
                                            size="small"
                                            defaultValue=""
                                            onChange={handleSearchChange}
                                            placeholder="Tìm kiếm username, ID..."
                                            sx={{
                                                minWidth: "240px",
                                                flex: "1 1 250px",
                                                "& .MuiInputBase-root": { height: "38px", fontSize: "13px", borderRadius: "6px" }
                                            }}
                                        />

                                        <select
                                            value={status}
                                            onChange={(e) => {
                                                setStatus(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{
                                                height: "38px",
                                                padding: "0 12px",
                                                borderRadius: "6px",
                                                border: "1px solid #cbd5e1",
                                                outline: "none",
                                                fontSize: "13px",
                                                color: "#334155",
                                                backgroundColor: "#ffffff",
                                                minWidth: "160px",
                                                cursor: "pointer",
                                                fontWeight: 500
                                            }}
                                        >
                                            <option value="All">Tất cả trạng thái</option>
                                            <option value="Pending">Chờ duyệt</option>
                                            <option value="Success">Thành công</option>
                                            <option value="Deny">Từ chối</option>
                                        </select>

                                        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                            <Typography variant="body2" sx={{ fontSize: "13px", fontWeight: 600, color: "#475569" }}>
                                                Từ:
                                            </Typography>
                                            <DatePicker
                                                maxDate={new Date()}
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    setPage(1);
                                                }}
                                                customInput={<CustomDateInput placeholder="Từ ngày" />}
                                            />
                                            <Typography variant="body2" sx={{ fontSize: "13px", fontWeight: 600, color: "#475569" }}>
                                                Đến:
                                            </Typography>
                                            <DatePicker
                                                maxDate={new Date()}
                                                selected={endDate}
                                                onChange={(date) => {
                                                    setEndDate(date);
                                                    setPage(1);
                                                }}
                                                customInput={<CustomDateInput placeholder="Đến ngày" />}
                                            />
                                        </Box>
                                    </Box>

                                    {/* Hàng lọc 2: Nút chọn nhanh mốc thời gian */}
                                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                                        {[
                                            { id: "all", label: "Tất cả ngày" },
                                            { id: "today", label: "Hôm nay" },
                                            { id: "yesterday", label: "Hôm qua" },
                                            { id: "thisWeek", label: "Tuần này" },
                                            { id: "thisMonth", label: "Tháng này" },
                                            { id: "lastMonth", label: "Tháng trước" }
                                        ].map((p) => {
                                            const isActive = datePreset === p.id;
                                            return (
                                                <Button
                                                    key={p.id}
                                                    size="small"
                                                    onClick={() => setDatePreset(p.id)}
                                                    sx={{
                                                        textTransform: "none",
                                                        height: "30px",
                                                        px: 1.8,
                                                        fontSize: "12px",
                                                        fontWeight: isActive ? 700 : 500,
                                                        borderRadius: "6px",
                                                        bgcolor: isActive ? "#0284c7" : "#f1f5f9",
                                                        color: isActive ? "#ffffff" : "#475569",
                                                        border: isActive ? "1px solid #0284c7" : "1px solid #cbd5e1",
                                                        "&:hover": { bgcolor: isActive ? "#0369a1" : "#e2e8f0" }
                                                    }}
                                                >
                                                    {p.label}
                                                </Button>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* Bảng Dữ Liệu Lịch Sử Hoàn Tiền - Spanning 100% Full Width */}
                        <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", bgcolor: "#ffffff", width: "100%" }}>
                            {loading && (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 5 }}>
                                    <CircularProgress size={36} />
                                </Box>
                            )}

                            {!loading && (
                                <Table className="full-width-table" sx={{ width: "100% !important", minWidth: "100% !important", margin: "0 !important", borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" }}>
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: "#f8fafc !important" }}>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "11%" }}>Tên Đăng Nhập</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "6%" }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "24%" }}>Chi Tiết Hoàn Trả</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "11%" }}>Tổng Cược</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "11%" }}>Tổng Thua</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "11%" }}>Số Tiền Hoàn</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "8%" }}>Trạng Thái</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "9%" }}>Hành Động</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: "#334155 !important", bgcolor: "#f8fafc !important", py: 1.8, fontSize: "13px", width: "9%" }}>Thời Gian</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data != null && data.length > 0 ? (
                                            data.map((item) => {
                                                const { tongCuoc, tongThua } = getBetAndLoss(item);
                                                return (
                                                    <TableRow key={item._id} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>
                                                            {item?.user?.username || "-"}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px" }}>
                                                            <Chip label={item?.user?.iduser || "-"} size="small" sx={{ bgcolor: "#f1f5f9", color: "#475569", fontWeight: 600, fontSize: "12px", height: 24 }} />
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px", color: "#334155", wordBreak: "break-word" }}>
                                                            {item?.detail || "-"}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px", fontWeight: 700, color: "#7c3aed" }}>
                                                            {tongCuoc ? `${formatPoints(tongCuoc)} điểm` : "0 điểm"}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px", fontWeight: 700, color: "#dc2626" }}>
                                                            {tongThua ? `${formatPoints(tongThua)} điểm` : "0 điểm"}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "13px", fontWeight: 700, color: "#16a34a" }}>
                                                            {item?.money ? formatPoints(Number(item.money)) : 0} điểm
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8 }}>
                                                            {renderStatusBadge(item?.status_payment)}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8 }}>
                                                            {item?.status_payment === "Pending" ? (
                                                                <Stack direction="row" spacing={1}>
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        onClick={() => handleUpdateStatus(item._id, "Accept")}
                                                                        sx={{
                                                                            bgcolor: "#16a34a",
                                                                            "&:hover": { bgcolor: "#15803d" },
                                                                            textTransform: "none",
                                                                            fontWeight: 600,
                                                                            fontSize: "12px",
                                                                            px: 1.5,
                                                                            py: 0.5,
                                                                            borderRadius: "6px",
                                                                            boxShadow: "none"
                                                                        }}
                                                                    >
                                                                        Xác nhận
                                                                    </Button>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="error"
                                                                        size="small"
                                                                        onClick={() => handleUpdateStatus(item._id, "Deny")}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            fontWeight: 600,
                                                                            fontSize: "12px",
                                                                            px: 1.5,
                                                                            py: 0.5,
                                                                            borderRadius: "6px"
                                                                        }}
                                                                    >
                                                                        Từ chối
                                                                    </Button>
                                                                </Stack>
                                                            ) : (
                                                                <Typography variant="caption" sx={{ color: "#94a3b8", fontStyle: "italic" }}>
                                                                    Đã xử lý
                                                                </Typography>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ py: 1.8, fontSize: "12px", color: "#64748b" }}>
                                                            {formatDateTime(item?.createdAt)}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={9} align="center" sx={{ py: 4, color: "#64748b" }}>
                                                    {t("empty")}
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            )}
                        </TableContainer>

                        {/* Phân trang */}
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            {data != null && totalPages > 1 ? (
                                <Pagination color="primary" page={page} count={totalPages} size="medium" onChange={handleChangePage} />
                            ) : null}
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Request;
